export enum FooterActionTypes {
  API_RESPONSE_SUCCESS = "@@footer/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@footer/API_RESPONSE_ERROR",

  CREATE_FOOTER = "@@footer/CREATE_FOOTER",
  GET_FOOTER = "@@footer/GET_FOOTER",
  UPDATE_FOOTER = "@@footer/UPDATE_FOOTER",
  DELETE_FOOTER = "@@footer/DELETE_FOOTER",
}
